<template>
  <div class="screenshots">
    <h1>Generador de QR</h1>
    <div class="controls">
      <div class="flex-row">
        <div>
          <label class="bolded">Ingresa el link para generar el QR</label>
          <input type="text" id="name" name="name" v-model="url_create" />
        </div>
        <div>
          <label class="bolded">Ingresa el nombre del QR</label>
          <input type="text" id="name" name="name" v-model="description_create" />
        </div>
      </div>

      <button type=" button" class="btn control upload-btn" @click="saveQR('')">Generar QR</button>
    </div>
    <v-server-table :columns="table_options.columns" :options="table_options.options" ref="screeshotsTable"
      id="screeshotsTable" class="screenshots__table">
      <template #reportDate="props">
        <span>{{ props.row.reportDateFormat }}</span>
      </template>
      <template #qrCode="props">
        <div v-if="props.row.qrCode === ''" class="gray">
          <span>No Image</span>
        </div>
        <div class="image-group" readonly v-html="props.row.svg">
        </div>
      </template>
      <template #download="props">
        <div class="actions" v-if="props.row.screenshot !== ''">
          <a :href="props.row.screenshot" target="_blank" download>
            <img class="mr-2" src="@/assets/img/icon/Download_icon.png" alt="Download Icon"
              @click="dowloadCode(props)" />

          </a>
        </div>
      </template>
      <template #actions="props" v-slot:actions="props">
        <div class="actions">

          <i @click="openEditModal('Editar categorías', 'edit', props)" class="icons-black far fa-edit"></i>
        </div>
      </template>
    </v-server-table>
    <!-- Modal -->
    <Modal v-if="newModalActive" v-on:closeModal="closeModal">
      <div v-if="error">
        <b-alert v-model="error" variant="danger" dismissible id="alert-modal">{{ textoError }}</b-alert>
      </div>
      <!-- Modal title -->
      <template #header>
        <span class="title">Editar QR</span>
      </template>
      <!-- Modal body -->
      <template>
        <div class="form-container">
          <!-- Name -->
          <div class="input-container">
            <label for="name">Link</label>
            <input type="text" id="name" name="name" v-model="url">
            <div class="error-msg">
            </div>
          </div>
          <div class="input-container">
            <label for="name">Nombre de QR</label>
            <input type="text" id="name" name="name" v-model="description">
            <div class="error-msg">
            </div>
          </div>

        </div>
      </template>
      <!-- Modal footer -->
      <template #footer>
        <div class="modal-actions">
          <span class="cancel-btn" @click="newModalActive = false">{{ $t("global.cancel") }}</span>
          <button type="button" class="btn btn-dark save-btn" @click="save('')">{{ $t("global.save") }}</button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import API_SERVICE from "@/lib/api/BurdenFile.js";
//import API_SERVICE from "@/lib/api/screenshots.js";
import S3_Handler from "@/lib/api/s3_handler";
const s3 = new S3_Handler();
const api = new API_SERVICE();
import Json2Csv from "vue-json-to-csv";
const Modal = () => import("@/components/Modal");
import { getFormattedDate } from '@/lib/utils';

export default {
  components: {
    Json2Csv,
    Modal,
  },
  data() {
    return {
      textoError: "",
      valorTurno: {},
      description: "",
      url: "",
      description_create:"",
      url_create: "",
      error: false,
      newModalActive: false,
      table_options: {},
      downloadData: [],
      csvData: [],
      dictionary: {
        fullName: this.$t("screenshots.table.headings.fullName"),
        controlNumber: this.$t("screenshots.table.headings.controlNumber"),
        dateApp: this.$t(
          "screenshots.table.headings.dateApp"
        ),
        section: this.$t("screenshots.table.headings.section"),
        screenshot: this.$t("screenshots.table.headings.screenshot"),
      },
      modalActive: false,
      imageObject: null,
    };
  },
  async beforeMount() {
    this.createTable();
    //await this.downloadTable();
  },
  methods: {
     
    dowloadCode: async function (props) {
      console.log(props);
      this.$store.commit("global/SET_LOADING", true);
      const data = await api.dowloadCodeQr(props.row.id);
      var svgBlob = new Blob([data], { type: "image/jpeg+xml;charset=utf-8" });
      var svgUrl = URL.createObjectURL(svgBlob);
      var downloadLink = document.createElement("a");
      downloadLink.href = svgUrl;
      downloadLink.download = "QR.svg";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      this.$store.commit("global/SET_LOADING", false);

    },
    viewImage: async function (props) {



    },
    save: async function (props) {

      if (!this.url || !this.description) {
        this.error = true;
        this.textoError = "Es necesario llenar todos los campos!";
      } else {
        this.$store.commit("global/SET_LOADING", true);
        this.error = false;
        const data = {
          "url": this.url,
          "description": this.description
        }
        await api.editDataQr(data, this.valorTurno.id);
        this.newModalActive = false;
      
      this.$store.commit("global/SET_LOADING", false);
      this.userTableQR.refresh();
      }
      this.url = "";
      this.description = "";

    },
    saveQR: async function (props) {
      

      if (!this.url_create || !this.description_create) {
        this.$store.commit("global/SET_ALERT", {
          msg: "Todos los campos son requeridos",
          show: true,
          type: "error"
        });
      } else {
        this.$store.commit("global/SET_LOADING", true);
        const data = {
          "url": this.url_create,
          "description": this.description_create
        }
        await api.createDataQr(data);
      this.url_create = "";
      this.description_create = "";
      this.$store.commit("global/SET_LOADING", false);
      this.userTableQR.refresh();
      }
      

    },
    openEditModal: function (category, type, props) {
      this.error = false;
      console.log(props);
      this.valorTurno = props.row;
      this.description = props.row.description;
      this.url = props.row.url;

      this.newModalActive = true;
    },
    closeModal: function () {

      this.newModalActive = false;
    },
    createTable: function () {
      this.table_options = {
        columns: this.table_columns,
        options: {
          columnsDropdown: false,
          filterByColumn: true,
          headings: this.table_headings,
          filterable: this.table_filters,
          sortable: [
            "id",
            "url",
            "createdAt",
            "description",
            "numScans",
            "code"
          ],
          orderBy: {
            ascending: false
          },
          sortIcon: {
            base: "fas",
            up: "fa-sort-up",
            down: "fa-sort-down",
            is: "fa-sort",
          },
          columnsClasses: {
            fullName: 'align-middle',
            controlNumber: 'align-middle',
            section: 'align-middle',
            dateApp: 'align-middle',
            actions: 'align-middle'
          },
          resizableColumns: false,
          perPage: 10,
          texts: {
            filterBy: "{column}",
            columns: this.$t("users.search.table.column_toggler"),
          },
          requestAdapter: function (data) {
            const queries = {};
            queries.page = data.page - 1;
            queries.limit = data.limit;
            queries.query = data.query;
            queries.orderBy = data.orderBy ? data.orderBy : "dateApp";
            queries.orderType = data.ascending ? "asc" : "desc";
            return queries;
          },
          requestFunction: async function (data) {
            this.$store.commit("global/SET_LOADING", true);
            try {
              const pageresponse = data.page * data.limit;
              let cadenaInicial=`?limit=${data.limit}&offset=${pageresponse}`;
              if(data.query.description){
                cadenaInicial+=`&description=${data.query.description}`;
              }
              if(data.query.id){
                cadenaInicial+=`&id=${data.query.id}`;
              }
              if(data.query.numScans){
                cadenaInicial+=`&numScans=${data.query.numScans}`;
              }
              if(data.query.url){
                cadenaInicial+=`&url=${data.query.url}`;
              }
              const response = await api.getListQr(cadenaInicial);

              for (let i = 0; i < response.data.items.length; i++) {
                response.data.items[i].svg = await api.dowloadCodeQr(response.data.items[i].id);

              }
              this.$store.commit("global/SET_LOADING", false);
              return response;
            } catch (error) {
              this.$store.commit("global/SET_LOADING", false);
              throw error;
            }
          },
          responseAdapter: function (response) {
            return {
              data: response.data.items,
              count: response.data.total,
            };
          },
        }
      };
    },
    openModal: function (imgObj) {
      this.modalActive = true;
      this.imageObject = imgObj;
    },
    closeModal: function () {
      this.modalActive = false;
    },

    itemsToDownload: function () {
      const itemsFields = [
        "id",
        "url",
        "createdAt",
        "description",
        "numScans",
        "code"
      ];
      let downloadArray = this.downloadData.map((item) => {
        let obj = {};
        itemsFields.forEach((field) => {
          obj[this._translateHeader(field)] = item[field];
        });

        return obj;
      });
      this.csvData = downloadArray;
    },
    _translateHeader(header) {
      if (this.dictionary.hasOwnProperty(header)) {
        return this.dictionary[header];
      }
      return header;
    },
  },
  computed: {
    userTableQR: function () {
      return this.$refs.screeshotsTable;
    },
    table_columns: function () {
      return [
        "id",//id
        "url",//url
        "createdAt",//createdAt
        "description",//description
        "numScans",//numScans
        "qrCode",
        "download",
        "actions"
      ];
    },
    table_headings: function () {
      if (this.table_columns) {
        const headings = {};
        this.table_columns.forEach((column) => {
          headings[column] = this.$t(`screenshots.table.headings.${column}`);
        });
        return headings;
      }
      return null;
    },
    table_filters: function () {
      return this.table_columns.filter(
        (column) =>
          column !== "actions" &&
          column !== "qrCode" &&
          column !== "createdAt" &&
          column !== "download"
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.screenshots {
  &__table {
    text-align: center;
    justify-content: center;
    margin-top: $global-padding * 2;
  }

  &__modal {
    &__body {
      display: flex;
      width: 100%;
      height: auto;
      max-height: 600px;
      max-width: 100%;
    }
  }

  .link {
    color: #000;
  }

  .link:hover {
    color: #000;
  }

  .download a {
    cursor: pointer;
    color: #000;

    &:hover {
      color: #000;
    }
  }

  .gray {
    background-color: #cccccc;
    height: 100px;
    width: 150px;
    margin-right: auto;
    margin-left: auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .image-group {
    width: 80px;
    height: 80px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    cursor: pointer;
  }
}

.alert-modal {
  width: 100%;
}

.controls {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 50px 0;

}

.controls .upload-btn {
  background-color: #000;
  border-radius: 0px;
  color: #fff;
  margin-left: 1rem;
}

.controls .upload-btn:hover {
  color: #fff;
}

.title {
  font-weight: bold;
  font-size: 1.2rem;
}

.modal-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;

  >* {
    margin-left: 1rem;
    cursor: pointer;
  }

  .cancel-btn {
    &:hover {
      text-decoration: underline;
    }
  }

  .save-btn {
    margin: 0 0 0 10px;
    color: white;
    background-color: black;
    border-color: black;
    padding: 10px 20px;
    border-radius: 0px;
    transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  }
}

.flex-row {
  display: flex;
  flex-direction: row;
}

.flex-row>div {
  margin: 0 10px;
}
</style>